// Messages for operator/settings/BulkIO (auto-merged into the i18n catalog by lib/i18n.ts).
export const en = {
  'operator.bulk_io.head': 'Import / Export — Operator',
  'operator.bulk_io.title': 'Import / Export',
  'operator.bulk_io.import.title': 'Import CSV',
  'operator.bulk_io.type': 'Type',
  'operator.bulk_io.import_type_aria': 'Import type',
  'operator.bulk_io.dry_run': 'Dry run',
  'operator.bulk_io.upload': 'Upload',
  'operator.bulk_io.dry_run_state': 'dry-run',
  'operator.bulk_io.commit_state': 'commit',
  'operator.bulk_io.stats': '{valid} ok / {invalid} errors',
  'operator.bulk_io.error_report': 'Error report',
  'operator.bulk_io.imports_empty': 'No imports yet.',
  'operator.bulk_io.export.title': 'Export CSV',
  'operator.bulk_io.download_kind': 'Download {kind}',
  'operator.bulk_io.queue_async': 'Queue async',
  'operator.bulk_io.rows': '{count} rows',
  'operator.bulk_io.download': 'Download',
}

export const zhTW = {
  'operator.bulk_io.head': '匯入／匯出 — 操作員',
  'operator.bulk_io.title': '匯入／匯出',
  'operator.bulk_io.import.title': '匯入 CSV',
  'operator.bulk_io.type': '類型',
  'operator.bulk_io.import_type_aria': '匯入類型',
  'operator.bulk_io.dry_run': '試運行',
  'operator.bulk_io.upload': '上傳',
  'operator.bulk_io.dry_run_state': '試運行',
  'operator.bulk_io.commit_state': '提交',
  'operator.bulk_io.stats': '{valid} 筆正常／{invalid} 筆錯誤',
  'operator.bulk_io.error_report': '錯誤報告',
  'operator.bulk_io.imports_empty': '尚無匯入。',
  'operator.bulk_io.export.title': '匯出 CSV',
  'operator.bulk_io.download_kind': '下載 {kind}',
  'operator.bulk_io.queue_async': '加入非同步佇列',
  'operator.bulk_io.rows': '{count} 列',
  'operator.bulk_io.download': '下載',
}
